module.exports = __webpack_public_path__ + "static/img_0827-7ff47334cae63e524b65b9090f1416c8.webp";